import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '../../../store';
import { tuttorialIndexStart, setPage, getHelpAssistance } from '../../../store/features/moments/momentsSlice';

const Accordion = withStyles({
    root: {
        justifyContent: 'space-between',
        borderRadius: '12px 12px 0 0',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&$expanded': {},
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'white',
        borderRadius: '12px 12px 0 0',
        borderBottom: '1px solid #EDEDED',
        display: 'flex',
        fontFamily: 'Roboto !important',
        padding: '0 26px 0 20px',
        justifyContent: 'space-between',
        width: '100%',
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
    root: {
        borderBottom: '1px solid #EDEDED',
        padding: '0 26px 0 20px',
        alignItems: 'center',
        fontFamily: 'Roboto !important',
    },
}))(MuiAccordionDetails);

const HelpCollapse = () => {
    const [expanded, setExpanded] = React.useState<string | false>('panel1');
    const { words } = useAppSelector(state => state.localization);
    const { helpAssistance, helpAsistanceAll, eventList } = useAppSelector(state => state.moments);

    const dispatch = useDispatch();

    const openWebChat = () => {
        const script = document.createElement('script');
        script.src = 'https://cdn.mindbehind.com/sdk/mindbehind-sdk.js?auto=true&key=626799a93bc90263bb695ed5';
        script.async = true;
        document.body.appendChild(script);
    };

    useEffect(() => {
        dispatch(getHelpAssistance());
    }, []);

    const handleChange = (panel: string) => (event, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleTutorial = () => {
        dispatch(setPage({ name: 'momentsHome', type: '', id: '' }));
        dispatch(tuttorialIndexStart(eventList.items.length > 0 ? 2 : 3));
    };

    const telephoneFormat = 'tel:+9' + (helpAssistance['WEB.Telephone'] ? helpAssistance['WEB.Telephone']?.split(' ').join('') : '');

    const mailFormat = 'mailto:' + (helpAssistance['WEB.Mail'] ? helpAssistance['WEB.Mail'] : '');

    return (
        <div className="collapse-menu">
            <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <a href="#!" className="button-03">
                        <svg className="icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="30" height="30" rx="8" fill="#D3D3D8" />
                            <path
                                d="M15 23.3333C19.6024 23.3333 23.3334 19.6024 23.3334 15C23.3334 10.3976 19.6024 6.66666 15 6.66666C10.3976 6.66666 6.66669 10.3976 6.66669 15C6.66669 19.6024 10.3976 23.3333 15 23.3333Z"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M15 18.3333C16.841 18.3333 18.3334 16.8409 18.3334 15C18.3334 13.159 16.841 11.6667 15 11.6667C13.1591 11.6667 11.6667 13.159 11.6667 15C11.6667 16.8409 13.1591 18.3333 15 18.3333Z"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M9.10834 9.10834L12.6417 12.6417" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17.3583 17.3583L20.8917 20.8917" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17.3583 12.6417L20.8917 9.10834" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17.3583 12.6417L20.3 9.70001" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9.10834 20.8917L12.6417 17.3583" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="text-01">{words && words['WEB.assistance']}</span>
                        <svg
                            className={expanded ? 'active accordion-arrow' : 'accordion-arrow'}
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                </AccordionSummary>
                <AccordionDetails>
                    {/* <a href="tel:+908503992233" className="collapse-menu-wrap"> */}
                    <a href={telephoneFormat} className="collapse-menu-wrap">
                        <svg className="collapse-menu-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22.0004 16.9201V19.9201C22.0016 20.1986 21.9445 20.4743 21.8329 20.7294C21.7214 20.9846 21.5577 21.2137 21.3525 21.402C21.1473 21.5902 20.905 21.7336 20.6412 21.8228C20.3773 21.912 20.0978 21.9452 19.8204 21.9201C16.7433 21.5857 13.7874 20.5342 11.1904 18.8501C8.77425 17.3148 6.72576 15.2663 5.19042 12.8501C3.5004 10.2413 2.44866 7.27109 2.12042 4.1801C2.09543 3.90356 2.1283 3.62486 2.21692 3.36172C2.30555 3.09859 2.44799 2.85679 2.63519 2.65172C2.82238 2.44665 3.05023 2.28281 3.30421 2.17062C3.5582 2.05843 3.83276 2.00036 4.11042 2.0001H7.11042C7.59573 1.99532 8.06621 2.16718 8.43418 2.48363C8.80215 2.80008 9.0425 3.23954 9.11042 3.7201C9.23704 4.68016 9.47187 5.62282 9.81042 6.5301C9.94497 6.88802 9.97408 7.27701 9.89433 7.65098C9.81457 8.02494 9.62928 8.36821 9.36042 8.6401L8.09042 9.9101C9.51398 12.4136 11.5869 14.4865 14.0904 15.9101L15.3604 14.6401C15.6323 14.3712 15.9756 14.1859 16.3495 14.1062C16.7235 14.0264 17.1125 14.0556 17.4704 14.1901C18.3777 14.5286 19.3204 14.7635 20.2804 14.8901C20.7662 14.9586 21.2098 15.2033 21.527 15.5776C21.8441 15.9519 22.0126 16.4297 22.0004 16.9201Z"
                                stroke="#7E7E92"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <span className="collapse-menu-content">{helpAssistance && helpAssistance['WEB.Telephone']}</span>
                    </a>
                </AccordionDetails>
                <AccordionDetails>
                    <a
                        className="collapse-menu-wrap"
                        href={helpAssistance && helpAssistance['WEB.Whatsapp']}
                        target="_blank"
                        rel="noreferrer noopener">
                        <svg className="collapse-menu-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
                                stroke="#7E7E92"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M15.9998 13.9895V15.1939C16.0002 15.3057 15.9773 15.4163 15.9324 15.5188C15.8875 15.6212 15.8217 15.7132 15.7391 15.7887C15.6566 15.8643 15.5591 15.9219 15.453 15.9577C15.3469 15.9935 15.2344 16.0068 15.1229 15.9967C13.8851 15.8625 12.6962 15.4404 11.6516 14.7643C10.6797 14.148 9.85571 13.3256 9.23813 12.3557C8.55834 11.3084 8.1353 10.116 8.00326 8.87518C7.99321 8.76417 8.00643 8.65228 8.04208 8.54665C8.07773 8.44102 8.13503 8.34395 8.21032 8.26163C8.28562 8.1793 8.37727 8.11353 8.47943 8.06849C8.58159 8.02346 8.69203 8.00014 8.80372 8.00004H10.0104C10.2056 7.99812 10.3949 8.06711 10.5429 8.19415C10.6909 8.32119 10.7876 8.4976 10.8149 8.69052C10.8658 9.07593 10.9603 9.45435 11.0965 9.81857C11.1506 9.96225 11.1623 10.1184 11.1302 10.2685C11.0981 10.4187 11.0236 10.5565 10.9155 10.6656L10.4046 11.1754C10.9772 12.1805 11.811 13.0126 12.8181 13.5841L13.3289 13.0743C13.4383 12.9663 13.5763 12.8919 13.7268 12.8599C13.8772 12.8279 14.0336 12.8396 14.1776 12.8936C14.5426 13.0295 14.9217 13.1238 15.3079 13.1746C15.5033 13.2021 15.6817 13.3003 15.8093 13.4506C15.9369 13.6009 16.0046 13.7927 15.9998 13.9895Z"
                                fill="#7E7E92"
                            />
                        </svg>
                        <span className="collapse-menu-content">
                            {helpAsistanceAll.items.length > 0 && helpAsistanceAll.items?.find(x => x.key === 'WEB.Whatsapp').title}
                        </span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                </AccordionDetails>

                <AccordionDetails>
                    <a className="collapse-menu-wrap" href={mailFormat}>
                        <svg className="collapse-menu-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                                stroke="#7E7E92"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M22 6L12 13L2 6" stroke="#7E7E92" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="collapse-menu-content">{helpAssistance && helpAssistance['WEB.Mail']}</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                </AccordionDetails>
                <AccordionDetails>
                    <a className="collapse-menu-wrap" onClick={openWebChat} href="#!">
                        <div className="collapse-menu-wrap">
                            <svg
                                className="collapse-menu-img"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                                    stroke="#7E7E92"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className="collapse-menu-content">{words && words['WEB.WebChat']}</span>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </a>
                </AccordionDetails>
                <AccordionDetails>
                    <a className="collapse-menu-wrap" onClick={handleTutorial} href="#!">
                        <div className="collapse-menu-wrap">
                            <svg
                                className="collapse-menu-img"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M4.5 16.4998C3 17.7598 2.5 21.4998 2.5 21.4998C2.5 21.4998 6.24 20.9998 7.5 19.4998C8.21 18.6598 8.2 17.3698 7.41 16.5898C7.02131 16.2188 6.50929 16.0045 5.97223 15.9879C5.43516 15.9712 4.91088 16.1536 4.5 16.4998V16.4998Z"
                                    stroke="#7E7E92"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12 14.9998L9 11.9998C9.53214 10.6192 10.2022 9.29582 11 8.04976C12.1652 6.18675 13.7876 4.65281 15.713 3.59385C17.6384 2.53489 19.8027 1.98613 22 1.99976C22 4.71976 21.22 9.49976 16 12.9998C14.7369 13.7985 13.3968 14.4685 12 14.9998V14.9998Z"
                                    stroke="#7E7E92"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M9 12H4C4 12 4.55 8.97002 6 8.00002C7.62 6.92002 11 8.00002 11 8.00002"
                                    stroke="#7E7E92"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M12 15V20C12 20 15.03 19.45 16 18C17.08 16.38 16 13 16 13"
                                    stroke="#7E7E92"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className="collapse-menu-content">{words && words['WEB.showMeAround']}</span>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </a>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default HelpCollapse;
